/* eslint-disable no-undef */
window.dataLayer = window.dataLayer || [];

function gtag() {
	dataLayer.push(arguments);
}

export default gtag;
